import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground text-background">
      <div className="container mx-auto px-4 py-16 lg:px-8">
        <div className="grid gap-8 md:grid-cols-4">
          <div>
            <div className="mb-4 flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary">
                <img src="/workscope-mark.svg" alt="WorkScope" className="h-5 w-5" width={20} height={20} />
              </div>
              <span className="text-xl font-bold">WorkScope</span>
            </div>
            <p className="text-sm opacity-70">
              {t("landing.footer.tagline")}
            </p>
          </div>

          <div>
            <p className="mb-3 text-sm font-semibold uppercase tracking-wider opacity-50">{t("landing.footer.product")}</p>
            <ul className="space-y-2 text-sm opacity-70">
              <li>
                <Link to="/#features" className="transition-opacity hover:opacity-100">
                  {t("nav.features")}
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="transition-opacity hover:opacity-100">
                  {t("nav.pricing")}
                </Link>
              </li>
              <li>
                <Link to="/#how-it-works" className="transition-opacity hover:opacity-100">
                  {t("nav.howItWorks")}
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="transition-opacity hover:opacity-100">
                  {t("nav.faq")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="mb-3 text-sm font-semibold uppercase tracking-wider opacity-50">{t("landing.footer.company")}</p>
            <ul className="space-y-2 text-sm opacity-70">
              <li>
                <a href="#" className="transition-opacity hover:opacity-100">
                  {t("landing.footer.about")}
                </a>
              </li>
              <li>
                <a href="#" className="transition-opacity hover:opacity-100">
                  {t("landing.footer.contact")}
                </a>
              </li>
              <li>
                <a href="#" className="transition-opacity hover:opacity-100">
                  {t("landing.footer.blog")}
                </a>
              </li>
              <li>
                <Link to="/affiliate" className="transition-opacity hover:opacity-100">
                  {t("landing.footer.affiliate")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="mb-3 text-sm font-semibold uppercase tracking-wider opacity-50">{t("landing.footer.legal")}</p>
            <ul className="space-y-2 text-sm opacity-70">
              <li>
                <Link to="/privacy" className="transition-opacity hover:opacity-100">
                  {t("landing.footer.privacy")}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="transition-opacity hover:opacity-100">
                  {t("landing.footer.terms")}
                </Link>
              </li>
              <li>
                <Link to="/sms-consent" className="transition-opacity hover:opacity-100">
                  {t("landing.footer.smsConsent")}
                </Link>
              </li>
              <li>
                <Link to="/sms-opt-in-proof" className="transition-opacity hover:opacity-100">
                  {t("landing.footer.smsOptInProof")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-background/20 pt-8 text-center text-sm opacity-50">
          {t("landing.footer.copyright", { year: new Date().getFullYear() })}
        </div>
      </div>
    </footer>
  );
}
